import getSmallestAllotmentCount from './getSmallestAllotmentCount'
import checkIfTravelClassIsEconomy from './checkIfTravelClassIsEconomy'

export default getSmallestAllotmentCount(checkIfTravelClassIsEconomy)
